import yup from 'yup'

const schema = yup
  .object()
  .shape({
    email: yup.string().email('Please enter a correct email').required('Email is required'),
  })

export default schema



// WEBPACK FOOTER //
// ./src/forms/ForgotPasswordForm/schema.js